import { forwardRef, useState } from 'react'
import type React from 'react'
import { type FieldVariant, textareaVariants } from './fieldStyles'

/** Styled textarea — twin of `Input` (same forwardRef requirement). */
export const Textarea = forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & { variant?: FieldVariant }
>(({ variant = 'underline', style, onFocus, onBlur, ...rest }, ref) => {
  const [focused, setFocused] = useState(false)
  const styles = textareaVariants[variant]
  return (
    <textarea
      ref={ref}
      {...rest}
      style={{
        ...styles.base,
        ...(focused ? styles.focus : {}),
        ...(rest.disabled ? { opacity: 0.45 } : {}),
        ...style,
      }}
      onFocus={(e) => {
        setFocused(true)
        onFocus?.(e)
      }}
      onBlur={(e) => {
        setFocused(false)
        onBlur?.(e)
      }}
    />
  )
})
Textarea.displayName = 'FormTextarea'
